export default __webpack_public_path__ + "static/media/hygiene.316d7eb5.jpg";